import axios from "axios";
import { navigate } from "../../common/navigator";

// W E B S I T E  L I N K
// Admin-Panel http://1.6.98.141:9065
// Customer-Panel http://1.6.98.141:5173


// local
// const baseURL = "http://192.168.3.225:9399/api/v1/";
// export const imageURL = "http://192.168.3.225:9399/";

// local
// const baseURL = "https://83c9f592c9f9.ngrok-free.app/api/v1/";
// export const imageURL = "https://83c9f592c9f9.ngrok-free.app/";

// //// Dell
// const baseURL = "http://1.6.98.141:9064/api/v1/";
// export const imageURL = "http://1.6.98.141:9064/";

// // Main Link
const baseURL = "https://mentalfit.azurewebsites.net/api/v1/";
export const imageURL = "https://mentalfit.azurewebsites.net/";

let APIKit = axios.create({
  baseURL,
  timeout: 600000,
});

APIKit.interceptors.request.use(async (config) => {
  const token = localStorage.token;
  const windowToken = window.token;

  // Set the Authorization header based on which tokens are available
  if (token || windowToken) {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = `Bearer ${windowToken}`;
    }
  }

  return config;
});

const statusCode = {
  success: 0,
  failure: 1,
  unAuthenticated: 2,
};

export const APIMethod = {
  GET(url, data, headers) {
    if (navigator.onLine) {
      return APIKit.get(url, data, {
        headers,
      })
        .then((data) => {
          if (data.status === 200 || data.status === 201) {
            return {
              result: data.data,
              status: statusCode.success,
            };
          } else if (data.status === 403 || data.status === 401) {
            localStorage.clear();
            navigate("/login");
            return {
              result: { message: data.data.message },
              status: statusCode.unAuthenticated,
            };
          } else {
            return {
              result: { data: data, message: "request failed" },
              status: statusCode.failure,
            };
          }
        })
        .catch((e) => {
          if (e.response.status === 403 || e.response.status === 401) {
            navigate("/login");
            localStorage.clear();
            return {
              result: { message: e.response.data.message },
              status: statusCode.unAuthenticated,
            };
          } else {
            return {
              result: {
                data: e.response.data.data,
                message: e.response.data.message,
              },
              status: statusCode.failure,
            };
          }
        });
    } else {
      return {
        result: { message: "Please check your internet connection." },
        status: statusCode.failure,
      };
    }
  },

  PUT(url, data, headers) {
    if (navigator.onLine) {
      return APIKit.put(url, data, {
        headers,
      })
        .then((data) => {
          if (data.status === 200 || data.status === 201) {
            return {
              result: data.data,
              status: statusCode.success,
            };
          } else if (data.status === 403 || data.status === 401) {
            localStorage.clear();
            navigate("/login");
            return {
              result: { message: data.data.message },
              status: statusCode.unAuthenticated,
            };
          } else {
            return {
              result: { message: "request failed" },
              status: statusCode.failure,
            };
          }
        })
        .catch((e) => {
          if (e.response.status === 403 || e.response.status === 401) {
            localStorage.clear();
            navigate("/login");
            return {
              result: { message: e.response.data },
              status: statusCode.unAuthenticated,
            };
          } else {
            return {
              result: { message: e.response.data.message },
              status: statusCode.failure,
            };
          }
        });
    } else {
      return {
        result: { message: "Please check your internet connection." },
        status: statusCode.failure,
      };
    }
  },
  POST(url, data, headers) {
    if (navigator.onLine) {
      return APIKit.post(url, data, {
        headers,
      })
        .then((data) => {
          if (data.status === 200 || data.status === 201) {
            return {
              result: data.data,
              status: statusCode.success,
            };
          } else if (data.status === 403 || data.status === 401) {
            localStorage.clear();
            navigate("/login");
            return {
              result: { message: data.data.message },
              status: statusCode.unAuthenticated,
            };
          } else {
            return {
              result: { message: "request failed" },
              status: statusCode.failure,
            };
          }
        })
        .catch((e) => {
          if (e.response.status === 403 || e.response.status === 401) {
            localStorage.clear();
            navigate("/login");
            return {
              result: { message: e.response.data.message },
              status: statusCode.unAuthenticated,
            };
          }
          return {
            result: {
              message: e.response.data.message,
              data: e.response.data.data,
            },
            status: statusCode.failure,
          };
        });
    } else {
      return {
        result: { message: "Please check your internet connection." },
        status: statusCode.failure,
      };
    }
  },
  DELETE(url, data, headers) {
    if (navigator.onLine) {
      return APIKit.delete(url, {
        headers,
        data: data,
      })
        .then((data) => {
          if (data.status === 200 || data.status === 201) {
            return {
              result: data.data,
              status: statusCode.success,
            };
          } else if (data.status === 403 || data.status === 401) {
            localStorage.clear();
            navigate("/login");
            return {
              result: { message: data.data.message },
              status: statusCode.unAuthenticated,
            };
          } else {
            return {
              result: { message: "request failed" },
              status: statusCode.failure,
            };
          }
        })
        .catch((e) => {
          if (e.response.status === 403 || e.response.status === 401) {
            localStorage.clear();
            navigate("/login");
            return {
              result: { message: e.response.data.message },
              status: statusCode.unAuthenticated,
            };
          } else {
            return {
              result: { message: e.response.data.message },
              status: statusCode.failure,
            };
          }
        });
    } else {
      return {
        result: { message: "Please check your internet connection." },
        status: statusCode.failure,
      };
    }
  },
};
